/**
 * A function to create a log object for the 'bmInfoClickInFullReviewPageSrc69Evid136' event (evid: 136)
 *
 * Event description: Sent when a user clicks on Info in mobile Review page
 *
 * @param {bmInfoClickInFullReviewPageSrc69Evid136Params} params - The parameters for this event
 * @property {string} review_id - review guid
 * @property {string} tab_name - name of current tab
 * @property {GUID} app_id - app_id
 * @property {GUID} msid - site id - msid
 * @property {GUID} uuid - uuid
 * @return {LogObject<bmInfoClickInFullReviewPageSrc69Evid136Params>} LogObject<bmInfoClickInFullReviewPageSrc69Evid136Params>
 */
export function bmInfoClickInFullReviewPageSrc69Evid136(params) {
    return { evid: 136, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmViewLiveClickInFullReviewPageSrc69Evid137' event (evid: 137)
 *
 * Event description: Sent when a user clicks on View Live in mobile Review page
 *
 * @param {bmViewLiveClickInFullReviewPageSrc69Evid137Params} params - The parameters for this event
 * @property {string} review_id - review guid
 * @property {string} tab_name - name of current tab
 * @property {GUID} app_id - app_id
 * @property {GUID} msid - site id - msid
 * @property {GUID} uuid - uuid
 * @return {LogObject<bmViewLiveClickInFullReviewPageSrc69Evid137Params>} LogObject<bmViewLiveClickInFullReviewPageSrc69Evid137Params>
 */
export function bmViewLiveClickInFullReviewPageSrc69Evid137(params) {
    return { evid: 137, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmRejectAReviewFailsSrc69Evid138' event (evid: 138)
 *
 * Event description: Sent when a user tries to reject (delete) a review and the process fails.
 *
 * @param {bmRejectAReviewFailsSrc69Evid138Params} params - The parameters for this event
 * @property {string} review_id - review guid
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @property {string} uuid - uuid
 * @return {LogObject<bmRejectAReviewFailsSrc69Evid138Params>} LogObject<bmRejectAReviewFailsSrc69Evid138Params>
 */
export function bmRejectAReviewFailsSrc69Evid138(params) {
    return { evid: 138, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmMobileActionClickSrc69Evid139' event (evid: 139)
 *
 * Event description: Sent when a user clicks on action inside Mobile Owner app.
 *
 * @param {bmMobileActionClickSrc69Evid139Params} params - The parameters for this event
 * @property {string} review_id - review guid
 * @property {string} tab_name - tab_name
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @property {string} action_type - view_live / reply / reject / publish / delete_review / delete_reply / edit_reply
 * @property {string} origin - list / full_review / three_dot
 * @return {LogObject<bmMobileActionClickSrc69Evid139Params>} LogObject<bmMobileActionClickSrc69Evid139Params>
 */
export function bmMobileActionClickSrc69Evid139(params) {
    return { evid: 139, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmMobileActionFail' event (evid: 140)
 *
 * Event description: Sent when an action in Mobile is failed
 *
 * @param {bmMobileActionFailParams} params - The parameters for this event
 * @property {string} review_id - review guid
 * @property {string} tab_name - tab_name
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @property {string} action_type - view_live / reply / reject / publish / delete_review / delete_reply / edit_reply
 * @return {LogObject<bmMobileActionFailParams>} LogObject<bmMobileActionFailParams>
 */
export function bmMobileActionFail(params) {
    return { evid: 140, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmMobileActionSuccess' event (evid: 141)
 *
 * Event description: Sent when an action inside Mobile app is successful
 *
 * @param {bmMobileActionSuccessParams} params - The parameters for this event
 * @property {string} review_id - review guid
 * @property {string} tab_name - tab_name
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @property {string} action_type -  reply / reject / publish / delete_review / delete_reply
 * @return {LogObject<bmMobileActionSuccessParams>} LogObject<bmMobileActionSuccessParams>
 */
export function bmMobileActionSuccess(params) {
    return { evid: 141, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reviewsSectionLoaded' event (evid: 8001)
 *
 * Event description: Event triggered when reviews are loaded (product page loaded).
 *
 * @param {reviewsSectionLoadedParams} params - The parameters for this event
 * @property {string} layout_type - type of layout
 * @property {number} page_count - total pages count
 * @property {GUID} visitor_id - visitor_id
 * @property {number} reviews_count - total reviews count
 * @property {string} origin - product_page (when scrolled down) / deeplink (when page opened using deeplink)
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {number} avg_rating - avg_rating
 * @property {GUID} msid - site id - msid
 * @return {LogObject<reviewsSectionLoadedParams>} LogObject<reviewsSectionLoadedParams>
 */
export function reviewsSectionLoaded(params) {
    return { evid: 8001, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'leaveAReviewButtonClicked' event (evid: 8002)
 *
 * Event description: Event triggered when Leave a Review button is clicked
 *
 * @param {leaveAReviewButtonClickedParams} params - The parameters for this event
 * @property {string} referral_info - email_notification / null (if it is not from email notification)
 * @property {GUID} visitor_id - visitor_id
 * @property {string} origin - empty_state / product_page / collection_page
 * @property {string} author_role - owner, member, anonymous
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {GUID} app_id - app id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @return {LogObject<leaveAReviewButtonClickedParams>} LogObject<leaveAReviewButtonClickedParams>
 */
export function leaveAReviewButtonClicked(params) {
    return { evid: 8002, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reviewPublishedSuccessfully' event (evid: 8003)
 *
 * Event description: Event triggered when Review is successfully published
 *
 * @param {reviewPublishedSuccessfullyParams} params - The parameters for this event
 * @property {number} image_count - how many images were added
 * @property {GUID} review_id - review guid
 * @property {boolean} is_edited - true for edited review, false for new review
 * @property {string} referral_info - email_notification / null (if it is not from email notification)
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_verified - 1 - Review is verified / 0 - Review is not verified
 * @property {string} review_text - review_text
 * @property {string} review_title - review title
 * @property {number} reviews_count - 1 - single review publish / 2 and more - bulk action publish
 * @property {number} rating - how many stars
 * @property {string} author_role - owner, member, anonymous
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {string} approver_role - role of approver (NULL if review was published without approval)
 * @property {number} video_count - how many videos were added
 * @property {GUID} msid - site id - msid
 * @property {GUID} approved_by - approver_id (NULL if review was published without approval)
 * @property {string} origin - collection_page / product_page / moderation
 * @return {LogObject<reviewPublishedSuccessfullyParams>} LogObject<reviewPublishedSuccessfullyParams>
 */
export function reviewPublishedSuccessfully(params) {
    return { evid: 8003, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'replyButtonClicked' event (evid: 8004)
 *
 * Event description: Event triggered when Reply button is clicked
 *
 * @param {replyButtonClickedParams} params - The parameters for this event
 * @property {GUID} review_id - parent review id to reply to
 * @property {GUID} visitor_id - visitor_id
 * @property {string} author_role - owner / member
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @return {LogObject<replyButtonClickedParams>} LogObject<replyButtonClickedParams>
 */
export function replyButtonClicked(params) {
    return { evid: 8004, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'helpfulButtonClicked' event (evid: 8005)
 *
 * Event description: Event triggered when upvote/downvote button is clicked
 *
 * @param {helpfulButtonClickedParams} params - The parameters for this event
 * @property {GUID} review_id - review id
 * @property {string} role - member / owner / anonymous
 * @property {GUID} visitor_id - visitor_id
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {number} downvotes_count - final downvotes_count
 * @property {number} upvotes_count - final upvotes_count
 * @property {GUID} msid - site id - msid
 * @property {string} action - upvote / downvote
 * @return {LogObject<helpfulButtonClickedParams>} LogObject<helpfulButtonClickedParams>
 */
export function helpfulButtonClicked(params) {
    return { evid: 8005, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'helpfulActionPublished' event (evid: 8006)
 *
 * Event description: Event triggered when upvote/downvote action is published
 *
 * @param {helpfulActionPublishedParams} params - The parameters for this event
 * @property {GUID} review_id - review_id
 * @property {GUID} visitor_id - visitor_id
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {number} downvotes_count - final downvotes_count
 * @property {number} upvotes_count - final upvotes_count
 * @property {GUID} msid - site id - msid
 * @property {string} action - upvote / downvote
 * @return {LogObject<helpfulActionPublishedParams>} LogObject<helpfulActionPublishedParams>
 */
export function helpfulActionPublished(params) {
    return { evid: 8006, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'showMoreClicked' event (evid: 8007)
 *
 * Event description: when user clicks Show more/Show less to expand review text
 *
 * @param {showMoreClickedParams} params - The parameters for this event
 * @property {GUID} review_id - parent review id to reply to
 * @property {GUID} visitor_id - visitor_id
 * @property {string} origin - main_screen / media_dialog
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @property {string} action_type - show_more / show_less
 * @return {LogObject<showMoreClickedParams>} LogObject<showMoreClickedParams>
 */
export function showMoreClicked(params) {
    return { evid: 8007, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sortReviewsOpenActions' event (evid: 8008)
 *
 * Event description: Event triggered when Sort Reviews button is clicked first time
 *
 * @param {sortReviewsOpenActionsParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {number} total_reviews - total reviews count under product, group, event etc.
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @return {LogObject<sortReviewsOpenActionsParams>} LogObject<sortReviewsOpenActionsParams>
 */
export function sortReviewsOpenActions(params) {
    return { evid: 8008, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'filterReviewsOpenActions' event (evid: 8009)
 *
 * Event description: Event triggered when Filter Reviews button is clicked first time(click or keyboard)
 *
 * @param {filterReviewsOpenActionsParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {number} total_reviews - total reviews count under product, group, event etc.
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @return {LogObject<filterReviewsOpenActionsParams>} LogObject<filterReviewsOpenActionsParams>
 */
export function filterReviewsOpenActions(params) {
    return { evid: 8009, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'sortReviewsActionClick' event (evid: 8010)
 *
 * Event description: Event triggered when filtering option is selected
 *
 * @param {sortReviewsActionClickParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {number} total_reviews - total reviews count under product, group, event etc.
 * @property {string} sort_by - newest / oldest / helpful / highest_rated / lowest_rated
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @return {LogObject<sortReviewsActionClickParams>} LogObject<sortReviewsActionClickParams>
 */
export function sortReviewsActionClick(params) {
    return { evid: 8010, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'filterReviewsActionClick' event (evid: 8011)
 *
 * Event description: Event triggered when action is clicked in Filter Reviews dropdown or by clicking on bars
 *
 * @param {filterReviewsActionClickParams} params - The parameters for this event
 * @property {string} filtered_by - all_stars / 1 / 2 / 3 / 4 / 5
 * @property {GUID} visitor_id - visitor_id
 * @property {number} total_reviews - total number of reviews
 * @property {string} origin - dropdown / bars
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @return {LogObject<filterReviewsActionClickParams>} LogObject<filterReviewsActionClickParams>
 */
export function filterReviewsActionClick(params) {
    return { evid: 8011, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dotsActionButtonOpenActions' event (evid: 8012)
 *
 * Event description: Event triggered after user clicks on 3 dots action button
 *
 * @param {dotsActionButtonOpenActionsParams} params - The parameters for this event
 * @property {GUID} review_id - review guid
 * @property {string} role - owner, member, anonymous
 * @property {GUID} visitor_id - visitor_id
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {string} type - review / reply
 * @property {GUID} msid - site id - msid
 * @return {LogObject<dotsActionButtonOpenActionsParams>} LogObject<dotsActionButtonOpenActionsParams>
 */
export function dotsActionButtonOpenActions(params) {
    return { evid: 8012, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'showMyReviewButtonClicked' event (evid: 8013)
 *
 * Event description: Event triggered when Show my Review button is clicked
 *
 * @param {showMyReviewButtonClickedParams} params - The parameters for this event
 * @property {GUID} review_id - review guid
 * @property {string} role - owner, member
 * @property {GUID} visitor_id - visitor_id
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @return {LogObject<showMyReviewButtonClickedParams>} LogObject<showMyReviewButtonClickedParams>
 */
export function showMyReviewButtonClicked(params) {
    return { evid: 8013, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dotsActionButtonActionClick' event (evid: 8014)
 *
 * Event description: Event triggered when clicking on one of the actions
 *
 * @param {dotsActionButtonActionClickParams} params - The parameters for this event
 * @property {GUID} review_id - review guid
 * @property {string} role - owner, member, anonymous
 * @property {GUID} visitor_id - visitor_id
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {string} type - review / reply
 * @property {GUID} msid - site id - msid
 * @property {string} action - edit, delete, copy_link
 * @return {LogObject<dotsActionButtonActionClickParams>} LogObject<dotsActionButtonActionClickParams>
 */
export function dotsActionButtonActionClick(params) {
    return { evid: 8014, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reviewDeleted' event (evid: 8015)
 *
 * Event description: Event triggered when review is deleted
 *
 * @param {reviewDeletedParams} params - The parameters for this event
 * @property {GUID} review_id - review id
 * @property {string} role - owner / member
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_verified - 1 - Review is verified / 0 - Review is not verified
 * @property {number} rating - how many stars
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {number} downvotes_count - downvotes_count
 * @property {number} upvotes_count - upvotes_count
 * @property {GUID} msid - site id - msid
 * @return {LogObject<reviewDeletedParams>} LogObject<reviewDeletedParams>
 */
export function reviewDeleted(params) {
    return { evid: 8015, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'publishReviewButtonClick' event (evid: 8021)
 *
 * Event description: Event triggered when Publish review button is click
 *
 * @param {publishReviewButtonClickParams} params - The parameters for this event
 * @property {number} image_count - how many images were added
 * @property {GUID} review_id - review guid for edit / null for new review
 * @property {boolean} is_edited - true for edited review, false for new review
 * @property {string} referral_info - email_notification / null (if it is not from email notification)
 * @property {GUID} visitor_id - visitor_id
 * @property {number} rating - how many stars
 * @property {string} author_role - owner, member, anonymous
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {number} video_count - how many videos were added
 * @property {GUID} msid - site id - msid
 * @property {string} origin - product_page / collection_page
 * @return {LogObject<publishReviewButtonClickParams>} LogObject<publishReviewButtonClickParams>
 */
export function publishReviewButtonClick(params) {
    return { evid: 8021, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'settingsTextfieldValueChange' event (evid: 8036)
 *
 * Event description: Event triggered when user changes textfield value
 *
 * @param {settingsTextfieldValueChangeParams} params - The parameters for this event
 * @property {string} tab_name - Settings / Display / Texts / Design / Support
 * @property {string} element_name - element_name
 * @property {GUID} visitor_id - visitor_id
 * @property {string} text - final text value
 * @property {string} group_name - group_name
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @return {LogObject<settingsTextfieldValueChangeParams>} LogObject<settingsTextfieldValueChangeParams>
 */
export function settingsTextfieldValueChange(params) {
    return { evid: 8036, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmReviewsSectionLoaded' event (evid: 8040)
 *
 * Event description: Event triggered when reviews  list come into BM view
 *
 * @param {bmReviewsSectionLoadedParams} params - The parameters for this event
 * @property {string} tab_name - tab_name
 * @property {number} reviews_count - total reviews count
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @return {LogObject<bmReviewsSectionLoadedParams>} LogObject<bmReviewsSectionLoadedParams>
 */
export function bmReviewsSectionLoaded(params) {
    return { evid: 8040, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmClickOnTab' event (evid: 8041)
 *
 * Event description: Event triggered when user clicks on tab
 *
 * @param {bmClickOnTabParams} params - The parameters for this event
 * @property {string} target_tab_name - name of target tab
 * @property {string} tab_name - name of current tab
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @return {LogObject<bmClickOnTabParams>} LogObject<bmClickOnTabParams>
 */
export function bmClickOnTab(params) {
    return { evid: 8041, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmReplyAndPublishClick' event (evid: 8045)
 *
 * Event description: Sent when a user clicks Reply and Publish button
 *
 * @param {bmReplyAndPublishClickParams} params - The parameters for this event
 * @property {string} tab_name - name of current tab
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @return {LogObject<bmReplyAndPublishClickParams>} LogObject<bmReplyAndPublishClickParams>
 */
export function bmReplyAndPublishClick(params) {
    return { evid: 8045, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmDeleteReview' event (evid: 8046)
 *
 * Event description: BM: Delete review.
 *
 * @param {bmDeleteReviewParams} params - The parameters for this event
 * @property {string} review_id - review_id or list of reiview_ids
 * @property {boolean} is_select_all - true if all reviews were selected
 * @property {string} tab_name - tab_name
 * @property {number} reviews_count - reviews count for bulk action
 * @property {string} origin - review_page / list / three_dot_action
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @return {LogObject<bmDeleteReviewParams>} LogObject<bmDeleteReviewParams>
 */
export function bmDeleteReview(params) {
    return { evid: 8046, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmOpenFullReviewPage' event (evid: 8047)
 *
 * Event description: Sent when a user clicks on review to open full review page
 *
 * @param {bmOpenFullReviewPageParams} params - The parameters for this event
 * @property {string} review_id - review guid
 * @property {string} tab_name - name of current tab
 * @property {string} origin - list / three_dot_action
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @return {LogObject<bmOpenFullReviewPageParams>} LogObject<bmOpenFullReviewPageParams>
 */
export function bmOpenFullReviewPage(params) {
    return { evid: 8047, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmThreeDotActionClickOnAction' event (evid: 8049)
 *
 * Event description: Sent when a user clicks on action inside three dot action menu
 *
 * @param {bmThreeDotActionClickOnActionParams} params - The parameters for this event
 * @property {string} review_id - review guid
 * @property {string} tab_name - tab_name
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @property {string} action_type - show_full / go_to_live / move_to_trash / delete / publish, reply (mobile), edit_reply, delete_reply
 * @property {string} origin - review / reply
 * @return {LogObject<bmThreeDotActionClickOnActionParams>} LogObject<bmThreeDotActionClickOnActionParams>
 */
export function bmThreeDotActionClickOnAction(params) {
    return { evid: 8049, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmClickOnProductNameOpenProductPage' event (evid: 8050)
 *
 * Event description: Sent when a user clicks on product name to open product page
 *
 * @param {bmClickOnProductNameOpenProductPageParams} params - The parameters for this event
 * @property {string} review_id - review guid
 * @property {string} tab_name - name of current tab
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @return {LogObject<bmClickOnProductNameOpenProductPageParams>} LogObject<bmClickOnProductNameOpenProductPageParams>
 */
export function bmClickOnProductNameOpenProductPage(params) {
    return { evid: 8050, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmSubmitReply' event (evid: 8051)
 *
 * Event description: Sent when a user enters text and presses Reply button
 *
 * @param {bmSubmitReplyParams} params - The parameters for this event
 * @property {string} review_id - review guid
 * @property {boolean} is_edited - true when editing reply
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @return {LogObject<bmSubmitReplyParams>} LogObject<bmSubmitReplyParams>
 */
export function bmSubmitReply(params) {
    return { evid: 8051, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmCancelWritingReply' event (evid: 8052)
 *
 * Event description: Sent when a user closes window
 *
 * @param {bmCancelWritingReplyParams} params - The parameters for this event
 * @property {string} review_id - review guid
 * @property {string} origin - cancel / X / Update
 * @property {boolean} is_editing - TRUE / FALSE (when cancelation is done in Edit mode, then TRUE else FALSE)
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @return {LogObject<bmCancelWritingReplyParams>} LogObject<bmCancelWritingReplyParams>
 */
export function bmCancelWritingReply(params) {
    return { evid: 8052, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmDeleteReply' event (evid: 8053)
 *
 * Event description: Sent when a user confirms deleting reply
 *
 * @param {bmDeleteReplyParams} params - The parameters for this event
 * @property {string} review_id - review guid
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @return {LogObject<bmDeleteReplyParams>} LogObject<bmDeleteReplyParams>
 */
export function bmDeleteReply(params) {
    return { evid: 8053, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmClickOnSettingsButton' event (evid: 8054)
 *
 * Event description: Sent when a user clicks on Settings button
 *
 * @param {bmClickOnSettingsButtonParams} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @return {LogObject<bmClickOnSettingsButtonParams>} LogObject<bmClickOnSettingsButtonParams>
 */
export function bmClickOnSettingsButton(params) {
    return { evid: 8054, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmOpenFiltersPanel' event (evid: 8055)
 *
 * Event description: Sent when a user clicks on Filter button
 *
 * @param {bmOpenFiltersPanelParams} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @property {string} current_filters - The current state of filters, following the filter trigger
 * @return {LogObject<bmOpenFiltersPanelParams>} LogObject<bmOpenFiltersPanelParams>
 */
export function bmOpenFiltersPanel(params) {
    return { evid: 8055, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmFiltersApplied' event (evid: 8056)
 *
 * Event description: Sent when a user changes filtering
 *
 * @param {bmFiltersAppliedParams} params - The parameters for this event
 * @property {string} tab_name - current tab name
 * @property {string} origin - filter_panel / reviews_list
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @property {string} action_type - "add"/"remove"
 * @property {string} current_filters - The current state of filters, following the filter trigger
 * @return {LogObject<bmFiltersAppliedParams>} LogObject<bmFiltersAppliedParams>
 */
export function bmFiltersApplied(params) {
    return { evid: 8056, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmClearFilters' event (evid: 8057)
 *
 * Event description: Sent when a user clears filters
 *
 * @param {bmClearFiltersParams} params - The parameters for this event
 * @property {string} tab_name - current tab name
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @return {LogObject<bmClearFiltersParams>} LogObject<bmClearFiltersParams>
 */
export function bmClearFilters(params) {
    return { evid: 8057, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmCloseFiltersPanel' event (evid: 8058)
 *
 * Event description: Sent when a user closes filters panel
 *
 * @param {bmCloseFiltersPanelParams} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @property {string} current_filters - The current state of filters, following the filter trigger
 * @return {LogObject<bmCloseFiltersPanelParams>} LogObject<bmCloseFiltersPanelParams>
 */
export function bmCloseFiltersPanel(params) {
    return { evid: 8058, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'showReviewApprovalModal' event (evid: 8061)
 *
 * Event description: Event triggered when review is sent to approval and informational modal is shown
 *
 * @param {showReviewApprovalModalParams} params - The parameters for this event
 * @property {GUID} review_id - review guid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @return {LogObject<showReviewApprovalModalParams>} LogObject<showReviewApprovalModalParams>
 */
export function showReviewApprovalModal(params) {
    return { evid: 8061, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'closeReviewApprovalModal' event (evid: 8062)
 *
 * Event description: Event triggered when user closes modal window
 *
 * @param {closeReviewApprovalModalParams} params - The parameters for this event
 * @property {GUID} review_id - review_id
 * @property {GUID} visitor_id - visitor_id
 * @property {string} origin - X / OK
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @return {LogObject<closeReviewApprovalModalParams>} LogObject<closeReviewApprovalModalParams>
 */
export function closeReviewApprovalModal(params) {
    return { evid: 8062, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'newReviewSubmittedForApproval' event (evid: 8065)
 *
 * Event description: Event triggered after Review is submitted for approval
 *
 * @param {newReviewSubmittedForApprovalParams} params - The parameters for this event
 * @property {number} image_count - how many images were added
 * @property {GUID} review_id - review guid
 * @property {string} referral_info - email_notification / null (if it is not from email notification)
 * @property {GUID} visitor_id - visitor_id
 * @property {string} review_text - review_text
 * @property {string} review_title - review title
 * @property {number} rating - how many stars
 * @property {string} author_role - owner, member, anonymous
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {number} video_count - how many videos were added
 * @property {GUID} msid - msid
 * @property {string} origin - product_page / collection_page
 * @return {LogObject<newReviewSubmittedForApprovalParams>} LogObject<newReviewSubmittedForApprovalParams>
 */
export function newReviewSubmittedForApproval(params) {
    return { evid: 8065, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'intentClickIntoReviewSection' event (evid: 8067)
 *
 * Event description: Event is triggered when user / UoU click into reviews section
 *
 * @param {intentClickIntoReviewSectionParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {string} origin - empty_state / product_page / collection_page
 * @property {string} author_role - owner, member, anonymous
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @return {LogObject<intentClickIntoReviewSectionParams>} LogObject<intentClickIntoReviewSectionParams>
 */
export function intentClickIntoReviewSection(params) {
    return { evid: 8067, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmReplyButtonClick' event (evid: 8068)
 *
 * Event description: Sent when a user clicks Reply button in BM when review window is opened
 *
 * @param {bmReplyButtonClickParams} params - The parameters for this event
 * @property {string} review_id - review guid
 * @property {string} tab_name - published / pending / rejected
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @property {string} origin - full_review / list
 * @return {LogObject<bmReplyButtonClickParams>} LogObject<bmReplyButtonClickParams>
 */
export function bmReplyButtonClick(params) {
    return { evid: 8068, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reviewsSectionLoadedInViewport' event (evid: 8069)
 *
 * Event description: Reviews section loaded in viewport.
 *
 * @param {reviewsSectionLoadedInViewportParams} params - The parameters for this event
 * @property {string} layout_type - type of layout
 * @property {number} page_count - total pages count
 * @property {GUID} visitor_id - visitor_id
 * @property {number} reviews_count - total reviews count
 * @property {string} origin - product_page (when scrolled down) / deeplink (when page opened using deeplink) / collection_page
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {number} avg_rating - avg_rating
 * @property {GUID} msid - site id - msid
 * @return {LogObject<reviewsSectionLoadedInViewportParams>} LogObject<reviewsSectionLoadedInViewportParams>
 */
export function reviewsSectionLoadedInViewport(params) {
    return { evid: 8069, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reviewSubmissionWarning' event (evid: 8070)
 *
 * Event description: Event triggered after Review is trying to be published, but not all necessary fields are filled.
 *
 * @param {reviewSubmissionWarningParams} params - The parameters for this event
 * @property {GUID} review_id - review guid
 * @property {GUID} visitor_id - visitor_id
 * @property {string} warning_reason - name / email / add_a_rating / review_title / review / add_images_videos
 * @property {string} author_role - owner, member, anonymous
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - msid
 * @property {string} origin - collection_page / product_page
 * @return {LogObject<reviewSubmissionWarningParams>} LogObject<reviewSubmissionWarningParams>
 */
export function reviewSubmissionWarning(params) {
    return { evid: 8070, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmEditReplyButtonClick' event (evid: 8072)
 *
 * Event description: Sent when a user clicks Edit reply button in BM when review window is opened
 *
 * @param {bmEditReplyButtonClickParams} params - The parameters for this event
 * @property {string} review_id - review guid
 * @property {string} tab_name - published / pending / rejected
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @return {LogObject<bmEditReplyButtonClickParams>} LogObject<bmEditReplyButtonClickParams>
 */
export function bmEditReplyButtonClick(params) {
    return { evid: 8072, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmDeleteIconClick' event (evid: 8073)
 *
 * Event description: Sent when a user clicks Delete icon in BM when review window is opened
 *
 * @param {bmDeleteIconClickParams} params - The parameters for this event
 * @property {string} review_id - review guid
 * @property {string} tab_name - published / pending / rejected
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @return {LogObject<bmDeleteIconClickParams>} LogObject<bmDeleteIconClickParams>
 */
export function bmDeleteIconClick(params) {
    return { evid: 8073, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmReviewSReplyIntentClick' event (evid: 8074)
 *
 * Event description: Sent when a user starts writing a reply in BM when review modal is opened
 *
 * @param {bmReviewSReplyIntentClickParams} params - The parameters for this event
 * @property {string} review_id - review guid
 * @property {string} tab_name - published / pending / rejected
 * @property {boolean} is_editing - TRUE when cursor is placed in editing mode, / FALSE
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @return {LogObject<bmReviewSReplyIntentClickParams>} LogObject<bmReviewSReplyIntentClickParams>
 */
export function bmReviewSReplyIntentClick(params) {
    return { evid: 8074, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reviewsCollectionPageLoaded' event (evid: 8075)
 *
 * Event description: Reviews collection page status loaded (You've already left a review, review is pending, ect)
 *
 * @param {reviewsCollectionPageLoadedParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {string} origin - collection_page
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @property {string} message - already_left_review / review_visible / error /  review_pending
 * @return {LogObject<reviewsCollectionPageLoadedParams>} LogObject<reviewsCollectionPageLoadedParams>
 */
export function reviewsCollectionPageLoaded(params) {
    return { evid: 8075, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmDeleteReplyModalCancelAction' event (evid: 8077)
 *
 * Event description: Sent when a user press cancel or X in Delete reply modal
 *
 * @param {bmDeleteReplyModalCancelActionParams} params - The parameters for this event
 * @property {GUID} review_id - review_id
 * @property {string} origin - X / Cancel
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @return {LogObject<bmDeleteReplyModalCancelActionParams>} LogObject<bmDeleteReplyModalCancelActionParams>
 */
export function bmDeleteReplyModalCancelAction(params) {
    return { evid: 8077, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmImportReviewsClick' event (evid: 8078)
 *
 * Event description: Event triggered when user clicks Import Reviews in BM
 *
 * @param {bmImportReviewsClickParams} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @return {LogObject<bmImportReviewsClickParams>} LogObject<bmImportReviewsClickParams>
 */
export function bmImportReviewsClick(params) {
    return { evid: 8078, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmThreeDotActionOpenMenu' event (evid: 8080)
 *
 * Event description: Sent when a user clicks on three dot action to open menu
 *
 *
 * @param {bmThreeDotActionOpenMenuParams} params - The parameters for this event
 * @property {string} review_id - review guid
 * @property {string} tab_name - tab_name
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @property {string} origin - review / reply
 * @return {LogObject<bmThreeDotActionOpenMenuParams>} LogObject<bmThreeDotActionOpenMenuParams>
 */
export function bmThreeDotActionOpenMenu(params) {
    return { evid: 8080, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reviewsBmThreeDotActionOpenMenuSrc69Evid8081' event (evid: 8081)
 *
 * Event description: Sent when a user clicks on three dot icon to open the three dot menu
 *
 * @param {reviewsBmThreeDotActionOpenMenuSrc69Evid8081Params} params - The parameters for this event
 * @property {GUID} app_id - app_id
 * @property {GUID} site_member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @property {string} tab_name - name of current tab
 * @property {GUID} review_id - review  guid
 * @return {LogObject<reviewsBmThreeDotActionOpenMenuSrc69Evid8081Params>} LogObject<reviewsBmThreeDotActionOpenMenuSrc69Evid8081Params>
 */
export function reviewsBmThreeDotActionOpenMenuSrc69Evid8081(params) {
    return { evid: 8081, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reviewPublishedServer' event (evid: 8501)
 *
 * Event description: Event triggered when Review is successfully published
 *
 * @param {reviewPublishedServerParams} params - The parameters for this event
 * @property {number} image_count - how many images were added
 * @property {GUID} review_id - review guid
 * @property {boolean} is_edited - true for edited review, false for new review
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_verified - true for verified review, false for other reviews
 * @property {string} review_text - review_text
 * @property {string} review_title - review title
 * @property {number} rating - rating
 * @property {string} origin_type - organic - indicates that the review was created organically / application - indicates that the review was created by application
 * @property {string} author_role - owner, member, anonymous
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {string} app_id - app_id
 * @property {string} member_id - site_member_id
 * @property {GUID} msid - msid
 * @return {LogObject<reviewPublishedServerParams>} LogObject<reviewPublishedServerParams>
 */
export function reviewPublishedServer(params) {
    return { evid: 8501, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reviewDeletedServer' event (evid: 8502)
 *
 * Event description: Event triggered when review is deleted
 *
 * @param {reviewDeletedServerParams} params - The parameters for this event
 * @property {number} image_count - how many images were added
 * @property {GUID} review_id - review guid
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_verified - true for verified review, false for other reviews
 * @property {number} rating - how many stars
 * @property {string} origin_type - organic - indicates that the review was created organically / application - indicates that the review was created by application
 * @property {string} author_role - owner, member, anonymous
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {string} app_id - app_id
 * @property {string} member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @return {LogObject<reviewDeletedServerParams>} LogObject<reviewDeletedServerParams>
 */
export function reviewDeletedServer(params) {
    return { evid: 8502, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'replyPublishedServer' event (evid: 8503)
 *
 * Event description: Event triggered when Reply is successfully published
 *
 * @param {replyPublishedServerParams} params - The parameters for this event
 * @property {boolean} is_edited - true for edited review, false for new review
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_verified - true for verified review, false for other reviews
 * @property {GUID} parent_review_id - parent review ID
 * @property {string} review_text - reply text
 * @property {string} review_title - reply title
 * @property {string} origin_type - organic - indicates that the review was created organically / application - indicates that the review was created by application
 * @property {string} author_role - owner, member
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {GUID} app_id - app_id
 * @property {string} member_id - site_member_id
 * @property {GUID} msid - site id - msid
 * @return {LogObject<replyPublishedServerParams>} LogObject<replyPublishedServerParams>
 */
export function replyPublishedServer(params) {
    return { evid: 8503, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'replyDeletedServer' event (evid: 8504)
 *
 * Event description: Event triggered when Reply is deleted
 *
 * @param {replyDeletedServerParams} params - The parameters for this event
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_verified - true for verified review, false for other reviews
 * @property {GUID} parent_review_id - parent review ID
 * @property {string} origin_type - organic - indicates that the review was created organically / application - indicates that the review was created by application
 * @property {string} author_role - owner, member
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {string} app_id - app_id
 * @property {string} member_id - site_member_id
 * @property {GUID} msid - msid
 * @return {LogObject<replyDeletedServerParams>} LogObject<replyDeletedServerParams>
 */
export function replyDeletedServer(params) {
    return { evid: 8504, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'helpfulButtonClickedServer' event (evid: 8505)
 *
 * Event description: Event triggered when Upvote/Downvote on review is published
 *
 * @param {helpfulButtonClickedServerParams} params - The parameters for this event
 * @property {GUID} review_id - review guid
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_verified - true for verified review, false for other reviews
 * @property {number} rating - how many stars
 * @property {string} origin_type - organic - indicates that the review was created organically / application - indicates that the review was created by application
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {GUID} app_id - app_id
 * @property {string} member_id - site_member_id
 * @property {number} upvotes_count - final upvotes_count after action
 * @property {GUID} msid - site id - msid
 * @property {string} action - upvote / downvote
 * @return {LogObject<helpfulButtonClickedServerParams>} LogObject<helpfulButtonClickedServerParams>
 */
export function helpfulButtonClickedServer(params) {
    return { evid: 8505, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reviewApprovalNewReviewSubmittedForApprovalServer' event (evid: 8506)
 *
 * Event description: Event triggered when Review is submitted for approval
 *
 * @param {reviewApprovalNewReviewSubmittedForApprovalServerParams} params - The parameters for this event
 * @property {number} image_count - image_count
 * @property {GUID} review_id - review guid
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_verified - true for verified review, false for other reviews
 * @property {string} review_text - review_text
 * @property {string} review_title - review_title
 * @property {number} rating - stars count
 * @property {string} origin_type - organic - indicates that the review was created organically / application - indicates that the review was created by application
 * @property {string} author_role - owner, member, anonymous
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {string} app_id - app_id
 * @property {string} member_id - author id
 * @property {GUID} msid - site msid
 * @return {LogObject<reviewApprovalNewReviewSubmittedForApprovalServerParams>} LogObject<reviewApprovalNewReviewSubmittedForApprovalServerParams>
 */
export function reviewApprovalNewReviewSubmittedForApprovalServer(params) {
    return { evid: 8506, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reviewApprovalReviewApprovedServer' event (evid: 8507)
 *
 * Event description: Event triggered when Review is approved
 *
 * @param {reviewApprovalReviewApprovedServerParams} params - The parameters for this event
 * @property {GUID} review_id - review guid
 * @property {boolean} is_verified - true for verified review, false for other reviews
 * @property {number} rating - stars count
 * @property {string} origin_type - organic - indicates that the review was created organically / application - indicates that the review was created by application
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {string} member_id - approver member id
 * @property {GUID} msid - site msid
 * @return {LogObject<reviewApprovalReviewApprovedServerParams>} LogObject<reviewApprovalReviewApprovedServerParams>
 */
export function reviewApprovalReviewApprovedServer(params) {
    return { evid: 8507, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reviewApprovalReviewDeletedServer' event (evid: 8508)
 *
 * Event description: Event triggered when Review is deleted from "waiting for approval" list
 *
 * @param {reviewApprovalReviewDeletedServerParams} params - The parameters for this event
 * @property {GUID} review_id - review_id
 * @property {boolean} is_verified - true for verified review, false for other reviews
 * @property {number} rating - stars count
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {string} member_id - owner or moderator member id
 * @property {GUID} msid - site msid
 * @return {LogObject<reviewApprovalReviewDeletedServerParams>} LogObject<reviewApprovalReviewDeletedServerParams>
 */
export function reviewApprovalReviewDeletedServer(params) {
    return { evid: 8508, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'reviewApprovalUpdatedReviewSubmittedForApprovalServer' event (evid: 8509)
 *
 * Event description: Event triggered when Review's content is updated and Review goes to approval
 *
 * @param {reviewApprovalUpdatedReviewSubmittedForApprovalServerParams} params - The parameters for this event
 * @property {number} image_count - image_count
 * @property {GUID} review_id - review guid
 * @property {GUID} visitor_id - visitor_id
 * @property {boolean} is_verified - true for verified review, false for other reviews
 * @property {string} review_text - review_text after update
 * @property {string} review_title - review_title after update
 * @property {number} rating - stars count after update
 * @property {string} origin_type - organic - indicates that the review was created organically / application - indicates that the review was created by application
 * @property {string} author_role - author_role
 * @property {string} parent_resource_id - review parent entity GUID (product, group, event etc)
 * @property {string} app_id - app_id
 * @property {string} member_id - author id
 * @property {string} previous_values - json object of previous values {"rating": 3, "review_text": "asd", "review_title":"rwqewq"}
 * @property {GUID} msid - site msid
 * @return {LogObject<reviewApprovalUpdatedReviewSubmittedForApprovalServerParams>} LogObject<reviewApprovalUpdatedReviewSubmittedForApprovalServerParams>
 */
export function reviewApprovalUpdatedReviewSubmittedForApprovalServer(params) {
    return { evid: 8509, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'fileUploaded' event (evid: 8510)
 *
 * Event description: Event triggered when a user tries to upload a CSV reviews file
 *
 * @param {fileUploadedParams} params - The parameters for this event
 * @property {string} file_ext - File extension
 * @property {boolean} success - 0 - upload failed / 1 - upload successful
 * @property {string} file_id - The file identifier (null if not successful)
 * @property {string} errorMessage - null if succesful
 * @property {GUID} biToken - metasite id
 * @property {number} file_size - The size of the file being uploaded (in bytes)
 * @property {string} type - initial_upload / replace_upload
 * @return {LogObject<fileUploadedParams>} LogObject<fileUploadedParams>
 */
export function fileUploaded(params) {
    return { evid: 8510, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'errorReviewsImport' event (evid: 8511)
 *
 * Event description: whenever an error is happening after trying to import reviews
 *
 * @param {errorReviewsImportParams} params - The parameters for this event
 * @property {GUID} biToken - msid
 * @property {number} num_reviews_failed_mandatory_field - num_reviews_failed_mandatory_field
 * @property {number} num_reviews_total - num_reviews_total
 * @property {number} num_reviews_failed_input_length - num_reviews_failed_input_length
 * @property {string} error_message - error message (file row + error type)
 * @property {number} num_reviews_failed_url_format - num_reviews_failed_url_format
 * @property {number} num_reviews_failed_total - num_reviews_failed_total
 * @property {number} num_reviews_failed_media_count - num_reviews_failed_media_count
 * @property {number} num_reviews_failed_date_format - num_reviews_failed_date_format
 * @property {number} num_reviews_failed_header - num_reviews_failed_header
 * @property {number} num_reviews_success - num_reviews_success
 * @return {LogObject<errorReviewsImportParams>} LogObject<errorReviewsImportParams>
 */
export function errorReviewsImport(params) {
    return { evid: 8511, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'settingsChangeTextHeaderPlaceholderPublishButtonLikeButtonReplyButton' event (evid: 8916)
 *
 * Event description: Settings: Change text (Header, Placeholder, Publish button, Like button, Reply button)
 *
 * @param {settingsChangeTextHeaderPlaceholderPublishButtonLikeButtonReplyButtonParams} params - The parameters for this event
 * @property {string} widget_id - widget_id
 * @property {GUID} biToken - site guid - msid
 * @property {GUID} uuid - uuid
 * @property {string} element_name - header / placeholder / publish button / comment list / like button / reply button
 * @property {string} text - optional custom text
 * @property {string} page_name - page name on which widget is installed
 * @property {GUID} site_member_id - site_member_id
 * @return {LogObject<settingsChangeTextHeaderPlaceholderPublishButtonLikeButtonReplyButtonParams>} LogObject<settingsChangeTextHeaderPlaceholderPublishButtonLikeButtonReplyButtonParams>
 */
export function settingsChangeTextHeaderPlaceholderPublishButtonLikeButtonReplyButton(params) {
    return { evid: 8916, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmReviewRequestsClick' event (evid: 9302)
 *
 * Event description: Event triggered when user clicks Review Requests in BM
 *
 * @param {bmReviewRequestsClickParams} params - The parameters for this event
 * @property {GUID} uuid - user id
 * @property {GUID} msid -  site id - msid
 * @property {GUID} app_id -  app_id
 * @return {LogObject<bmReviewRequestsClickParams>} LogObject<bmReviewRequestsClickParams>
 */
export function bmReviewRequestsClick(params) {
    return { evid: 9302, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmReviewsMoreActionsClick' event (evid: 9303)
 *
 * Event description: Event triggered when user clicks More actions in BM
 *
 * @param {bmReviewsMoreActionsClickParams} params - The parameters for this event
 * @property {GUID} uuid - user id
 * @property {GUID} msid -  site id - msid
 * @property {GUID} app_id -  app_id
 * @return {LogObject<bmReviewsMoreActionsClickParams>} LogObject<bmReviewsMoreActionsClickParams>
 */
export function bmReviewsMoreActionsClick(params) {
    return { evid: 9303, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmReviewRequestsClickOnTab' event (evid: 9304)
 *
 * Event description: Event triggered when user clicks on tab in BM in Review Requests part
 *
 * @param {bmReviewRequestsClickOnTabParams} params - The parameters for this event
 * @property {string} target_tab_name - scheduled / sent / undelivered
 * @property {string} tab_name - scheduled / sent / undelivered
 * @property {GUID} app_id - app_id
 * @property {GUID} msid - msid
 * @property {GUID} uuid - uuid
 * @return {LogObject<bmReviewRequestsClickOnTabParams>} LogObject<bmReviewRequestsClickOnTabParams>
 */
export function bmReviewRequestsClickOnTab(params) {
    return { evid: 9304, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmReviewRequestsAutomationSettingsClick' event (evid: 9305)
 *
 * Event description: Event triggered when user clicks Automation Settings in Review Requests section in BM
 *
 * @param {bmReviewRequestsAutomationSettingsClickParams} params - The parameters for this event
 * @property {GUID} uuid - user id
 * @property {GUID} msid -  site id - msid
 * @property {GUID} app_id -  app_id
 * @return {LogObject<bmReviewRequestsAutomationSettingsClickParams>} LogObject<bmReviewRequestsAutomationSettingsClickParams>
 */
export function bmReviewRequestsAutomationSettingsClick(params) {
    return { evid: 9305, src: 69, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bmReviewRequestsOpenFullReviewRequestPage' event (evid: 9306)
 *
 * Event description: Sent when a user clicks on review request to open full page
 *
 * @param {bmReviewRequestsOpenFullReviewRequestPageParams} params - The parameters for this event
 * @property {GUID} review_request_id - review_request_id
 * @property {string} tab_name - tab_name
 * @property {string} origin - origin
 * @property {GUID} app_id - app_id
 * @property {GUID} msid - msid
 * @property {GUID} uuid - uuid
 * @return {LogObject<bmReviewRequestsOpenFullReviewRequestPageParams>} LogObject<bmReviewRequestsOpenFullReviewRequestPageParams>
 */
export function bmReviewRequestsOpenFullReviewRequestPage(params) {
    return { evid: 9306, src: 69, endpoint: '', params };
}
//# sourceMappingURL=index.js.map